/**
 * 突发性线索总路由
 * 2017-11-9
 * Bai.Zhiming
 */
"use strict";
angular.module("suddenCluesRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("front.plan.realtimeclues.suddenclues.newsmonitor", {
        url: "/newsmonitor", //爆料监控
        views: {
            "main@front.plan.realtimeclues.suddenclues": {
                template: "<div ui-view='main'></div>",
            }
        }
    }).
    state("front.plan.realtimeclues.suddenclues.zjpublicopinion", {
        url: "/zjpublicopinion", //新疆舆情
        views: {
            "main@front.plan.realtimeclues.suddenclues": {
                templateUrl: "./planningCenter/realTimeClues/suddenClues/zjPublicOpinion/zjPublicOpinion_tpl.html",
                controller: "zjPublicopinionCtrl"
            }
        }
    }).
    state("front.plan.realtimeclues.suddenclues.disasteraccident", {
        url: '/disasteraccident',
        views: {
            "main@front.plan.realtimeclues.suddenclues": {
                template: "<div ui-view='nav'></div><div ui-view='main'></div>"
            },
            "nav@front.plan.realtimeclues.suddenclues.disasteraccident": {
                templateUrl: './planningCenter/realTimeClues/suddenClues/disasterAccident/nav_tpl.html',
                controller: "navTplCtr"
            }
        }
    }).
    state("front.plan.realtimeclues.suddenclues.customsentiment", {
        url: '/customsentiment',
        views: {
            "main@front.plan.realtimeclues.suddenclues": {
                templateUrl: "./planningCenter/realTimeClues/suddenClues/customSentiment/customSentiment_tpl.html",
                controller: "customSentimentCtrl"
            }
        }
    });
}]);